import { render, staticRenderFns } from "./ServiceRegisterForm.vue?vue&type=template&id=666e2fa8&"
import script from "./ServiceRegisterForm.vue?vue&type=script&lang=ts&"
export * from "./ServiceRegisterForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports